import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
  Title,
} from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-document-comparison',
  templateUrl: './document-comparison.component.html',
  styleUrls: ['./document-comparison.component.scss'],
})
export class DocumentComparisonComponent implements OnInit, OnDestroy {
  viewerUrl: SafeResourceUrl;
  private subscriptions = new Subscription();
  id: string;
  title: string;
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.subscriptions.add(
      this.route.params.subscribe((params) => {
        this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          atob(params['id'])
        );
        this.title = params['title'];
        this.titleService.setTitle(
          'PDF Diff: ' + this.title + ' - InSPire Direct'
        );
      })
    );
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  closeTab() {
    window.close();
  }
}
